import { render } from "./Classes.vue?vue&type=template&id=5b02dd80"
import script from "./Classes.vue?vue&type=script&lang=js"
export * from "./Classes.vue?vue&type=script&lang=js"

import "./Classes.vue?vue&type=style&index=0&id=5b02dd80&lang=css"

import exportComponent from "D:\\childu_lms\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__